export default __webpack_public_path__ + "static/media/whatsapp_icon.c14492d9.svg";